<template>
  
<span>

    <Menu/>

    <!-- <b-row>
	
		

      <b-col>
        <p class="display-2" style="text-align:center;">
          
          

          <b-iconstack>
            <b-icon stacked icon="x-diamond-fill" scale="0.75" variant="secondary" style="color:#10486A"/>
            <b-icon stacked icon="check-all" variant="primary"/>
            
          </b-iconstack>

        </p>

      </b-col>

      

    </b-row> -->

    <!-- <b-row no-gutters class="mt-2" align-h="center">


        <b-col cols="2" md="2">
            <div style="text-align:left; v-align:bottom">
                <b-button href="#" variant="info" @click="previous()">
                    <b-icon icon="chevron-left"/>
                </b-button>
            </div>
        </b-col>
        <b-col cols="5" md="4">
            
        </b-col>
        <b-col cols="2" md="2">
            <div style="text-align:right; v-align:bottom">
                <b-button href="#" variant="info" @click="next('cardDashboard')">
                    <b-icon icon="chevron-right"/>
                </b-button>
            </div>
        </b-col>

    </b-row> -->
    
    <!-- <b-row no-gutters class="mt-2" align-h="center">

        <b-col cols="2" style="font-size:5rem;" align-self="start">
            
            <div class="w-100" style="text-align:center;">
            
                <a @click="previous">
                    <b-icon icon="chevron-compact-left"/>
                </a>

            </div>

        </b-col>
        
        <b-col cols="8">

            <center>
            
            <b-card v-if="nextRef == 'cardFeatures'"
                id="cardFeatures"
                ref="cardFeatures"
                title="Features"
                sub-title="Principal Task contains a wealth of features; all of which are available regardless of your subscription type.  Hover over each icon for details."
                :img-src="require('.././assets/tour/logo.png')"
                img-alt="Image"
                img-top
                tag="article"
                style="max-width: 50rem"
                class="mb-2">

                <b-card-text class="h-100 d-inline-block" style="text-align:center">
                    <b-button variant="light" id="feature-priority" class="m-1" size="sm">
                        <b-icon icon="exclamation"/><br/>
                    </b-button>
                    
                    <b-popover target="feature-priority" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Priority</template>
                        Stay on top of important tasks by setting their priority.
                    </b-popover>

                    <b-button variant="light" id="feature-context" class="m-1" size="sm">
                        <b-icon icon="at"/><br/>
                    </b-button>

                    <b-popover target="feature-context" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Context</template>
                        Organize your tasks by where you are or what tools you have available.
                    </b-popover>

                    <b-button variant="light" id="feature-folder" class="m-1" size="sm">
                        <b-icon icon="folder"/><br/>
                    </b-button>

                    <b-popover target="feature-folder" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Folder</template>
                        Keep similar tasks together by organizing them into folders.
                    </b-popover>

                    <b-button variant="light" id="feature-nested-folders" class="m-1" size="sm">
                        <b-icon icon="list-nested"/><br/>
                    </b-button>

                    <b-popover target="feature-nested-folders" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Folder Groups</template>
                        Group folders into group to separate the various aspects of your life.
                    </b-popover>

                    <b-button variant="light" id="feature-date" class="m-1" size="sm">
                        <b-icon icon="calendar"/><br/>
                    </b-button>

                    <b-popover target="feature-date" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Dates</template>
                        Never again forget to start or finish or something!
                    </b-popover>

                    <b-button variant="light" id="feature-star" class="m-1" size="sm">
                        <b-icon icon="star"/><br/>
                    </b-button>

                    <b-popover target="feature-star" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Star</template>
                        Star important tasks so they're easily spotted as your scroll through your list.
                    </b-popover>

                    <b-button variant="light" id="feature-visibility" class="m-1" size="sm">
                        <b-icon icon="arrows-expand"/><br/>
                    </b-button>

                    <b-popover target="feature-visibility" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Visibility</template>
                        See as much or as little detail as you desire.
                    </b-popover>

                    <b-button variant="light" id="feature-subtasks" class="m-1" size="sm">
                        <b-icon icon="file-plus"/><br/>
                    </b-button>

                    <b-popover target="feature-subtasks" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Sub-tasks</template>
                        Create a plan by adding sub-tasks (aka child tasks).
                    </b-popover>

                    <b-button variant="light" id="feature-status" class="m-1" size="sm">
                        <b-icon icon="circle-half"/><br/>
                    </b-button>

                    <b-popover target="feature-status" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Status</template>
                        Quickly determine the status of each task.
                    </b-popover>

                    <b-button variant="light" id="feature-filter" class="m-1" size="sm">
                        <b-icon icon="filter"/><br/>
                    </b-button>

                    <b-popover target="feature-filter" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Filters</template>
                        Only see the tasks that are most important to you in the moment by taking advantage of
                        canned and custom filters.
                    </b-popover>

                    <b-button variant="light" id="feature-repeat" class="m-1" size="sm">
                        <b-icon icon="arrow-repeat"/><br/>
                    </b-button>

                    <b-popover target="feature-repeat" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Repeat</template>
                        Setup your repetative actions as repeating tasks.
                    </b-popover>

                    <b-button variant="light" id="feature-import" class="m-1" size="sm">
                        <b-icon icon="box-arrow-down"/><br/>
                    </b-button>

                    <b-popover target="feature-import" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Import</template>
                        Easily switch from ToodleDo to Principal Task. (Other import options are coming soon.)
                    </b-popover>

                    <b-button variant="light" id="feature-dashboard" class="m-1" size="sm">
                        <b-icon icon="pie-chart-fill"/><br/>
                    </b-button>

                    <b-popover target="feature-dashboard" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Dashboard</template>
                        Easily judge the demands of your week and your productivity.
                    </b-popover>

                    <b-button variant="light" id="feature-mobile" class="m-1" size="sm">
                        <b-icon icon="phone"/><br/>
                    </b-button>

                    <b-popover target="feature-mobile" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Mobile-friendly</template>
                        The full power of Principal Task is available from any internet-connected device without
                        having to install a separate app.
                    </b-popover>
                </b-card-text>
                
                <template v-slot:footer>
                    <div style="text-align:center; v-align:middle">
                        <b-button to="signup" variant="success">
                            Get Started
                        </b-button>
                    </div>
                </template>

            </b-card>

            <b-card  v-if="nextRef == 'cardDashboard'"
                title="Dashboard"
                sub-title="Quickly review your horizon - that which is due soon - as well as helping you to review how productive you've been."
                id="cardDashboard"
                ref="cardDashboard"
                :img-src="require('.././assets/tour/dashboard-animated.png')"
                img-alt="Image"
                img-top
                tag="article"
                style="max-width: 50rem"
                class="mb-2">

                <template v-slot:footer>
                    <div style="text-align:center; v-align:middle">
                        <b-button to="signup" variant="success">
                            Get Started
                        </b-button>
                    </div>
                </template>

            </b-card>

            <b-card  v-if="nextRef == 'cardQuickAdd'"
                id="cardQuickAdd"
                ref="cardQuickAdd"
                title="Quick Add"
                sub-title="Short on time? Add tasks quickly from the top of the page."
                :img-src="require('.././assets/tour/quick-add-animated.png')"
                img-alt="Image"
                img-top
                tag="article"
                style="max-width: 50rem"
                class="mb-2">

                <template v-slot:footer>
                    <div style="text-align:center; v-align:middle">
                        <b-button to="signup" variant="success">
                            Get Started
                        </b-button>
                    </div>
                </template>

            </b-card>

            
            <b-card  v-if="nextRef == 'cardDetailAdd'"
                id="cardDetailAdd"
                ref="cardDetailAdd"
                title="Detailed Add"
                sub-title="Stay completely organized by creating a task with all of the important details."
                :img-src="require('.././assets/tour/detailed-add-animated.png')"
                img-alt="Image"
                img-top
                tag="article"
                style="max-width: 50rem"
                class="mb-2">

                <template v-slot:footer>
                    <div style="text-align:center; v-align:middle">
                        <b-button to="signup" variant="success">
                            Get Started
                        </b-button>
                    </div>
                </template>


            </b-card>

            <b-card  v-if="nextRef == 'joinNow'"
                id="joinNow"
                ref="joinNow"
                title="Join Today"
                sub-title="Free and paid plans available."
                :img-src="require('.././assets/stock/do-more.jpg')"
                img-alt="Image"
                img-top
                tag="article"
                style="max-width: 50rem"
                class="mb-2">

                <template v-slot:footer>
                    <div style="text-align:center; v-align:middle">
                        <b-button to="signup" variant="success">
                            Get Started
                        </b-button>
                    </div>
                </template>

            </b-card>

            </center>

        </b-col>

        <b-col cols="2" style="font-size:5rem;" align-self="start">
            
            <div class="w-100" style="text-align:center;">
            
                <a @click="next">
                    <b-icon icon="chevron-compact-right"/>
                </a>

            </div>

        </b-col>


    </b-row> -->


<!--  cols="12" md="8" -->
    

	<b-row class="mt-2">
        <b-col>

         <!-- <center>
            <p class="display-4">
                Tour
            </p>
            <p class="lead">
                A brief overview of Principal Task
            </p>
        </center> -->
        
        <center>
        
        


        
        
         <b-carousel
            id="carousel-1"
            :interval="0"
            controls
            indicators
            background="#C9CBCB"
            class="w-100">
            
            <b-carousel-slide
                style="color:black; text-shadow: 1px 1px 2px #333">

                    <template v-slot:img>
                        <b-img
                            :d-block="true"
                            :fluid="true"
                            :src="require('.././assets/tour/logo.png')"
                            alt="image slot"
                            :rounded="true"/>
                    </template>

                    <h3 class="d-none d-sm-block">
                        Features
                    </h3>

                    <p>
                        Principal Task contains a wealth of features; all of which are available 
                        regardless of your subscription type.
                    </p>
                
                    <span class="d-sm-none">
                        (Rotate your device for details.)
                    </span>

                    <span class="d-none d-sm-block">
                    
                    <b-button variant="light" id="feature-priority" class="m-1" size="sm">
                        <b-icon icon="exclamation"/><br/>
                    </b-button>
                    
                    <b-popover target="feature-priority" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Priority</template>
                        Stay on top of important tasks by setting their priority.
                    </b-popover>

                    <b-button variant="light" id="feature-context" class="m-1" size="sm">
                        <b-icon icon="at"/><br/>
                    </b-button>

                    <b-popover target="feature-context" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Context</template>
                        Organize your tasks by where you are or what tools you have available.
                    </b-popover>

                    <b-button variant="light" id="feature-folder" class="m-1" size="sm">
                        <b-icon icon="folder"/><br/>
                    </b-button>

                    <b-popover target="feature-folder" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Folder</template>
                        Keep similar tasks together by organizing them into folders.
                    </b-popover>

                    <b-button variant="light" id="feature-nested-folders" class="m-1" size="sm">
                        <b-icon icon="list-nested"/><br/>
                    </b-button>

                    <b-popover target="feature-nested-folders" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Folder Groups</template>
                        Group folders into group to separate the various aspects of your life.
                    </b-popover>

                    <b-button variant="light" id="feature-date" class="m-1" size="sm">
                        <b-icon icon="calendar"/><br/>
                    </b-button>

                    <b-popover target="feature-date" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Dates</template>
                        Never again forget to start or finish or something!
                    </b-popover>

                    <b-button variant="light" id="feature-remind" class="m-1" size="sm">
                        <b-icon icon="alarm-fill"/><br/>
                    </b-button>

                    <b-popover target="feature-remind" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Reminders</template>
                        Get reminders about your tasks using <b-link href="https://www.pushover.net" target="_new">Pushover</b-link>.
                    </b-popover>

                    <b-button variant="light" id="feature-star" class="m-1" size="sm">
                        <b-icon icon="star"/><br/>
                    </b-button>

                    <b-popover target="feature-star" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Star</template>
                        Star important tasks so they're easily spotted as your scroll through your list.
                    </b-popover>

                    <b-button variant="light" id="feature-visibility" class="m-1" size="sm">
                        <b-icon icon="arrows-expand"/><br/>
                    </b-button>

                    <b-popover target="feature-visibility" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Visibility</template>
                        See as much or as little detail as you desire.
                    </b-popover>

                    <b-button variant="light" id="feature-subtasks" class="m-1" size="sm">
                        <b-icon icon="file-plus"/><br/>
                    </b-button>

                    <b-popover target="feature-subtasks" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Sub-tasks</template>
                        Create a plan by adding sub-tasks (aka child tasks).
                    </b-popover>

                    <b-button variant="light" id="feature-status" class="m-1" size="sm">
                        <b-icon icon="circle-half"/><br/>
                    </b-button>

                    <b-popover target="feature-status" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Status</template>
                        Quickly determine the status of each task.
                    </b-popover>

                    <b-button variant="light" id="feature-filter" class="m-1" size="sm">
                        <b-icon icon="filter"/><br/>
                    </b-button>

                    <b-popover target="feature-filter" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Filters</template>
                        Only see the tasks that are most important to you in the moment by taking advantage of
                        canned and custom filters.
                    </b-popover>

                    <b-button variant="light" id="feature-repeat" class="m-1" size="sm">
                        <b-icon icon="arrow-repeat"/><br/>
                    </b-button>

                    <b-popover target="feature-repeat" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Repeat</template>
                        Setup your repetative actions as repeating tasks.
                    </b-popover>

                    <b-button variant="light" id="feature-import" class="m-1" size="sm">
                        <b-icon icon="box-arrow-down"/><br/>
                    </b-button>

                    <b-popover target="feature-import" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Import</template>
                        Easily switch from ToodleDo to Principal Task. (Other import options are coming soon.)
                    </b-popover>

                    <b-button variant="light" id="feature-dashboard" class="m-1" size="sm">
                        <b-icon icon="pie-chart-fill"/><br/>
                    </b-button>

                    <b-popover target="feature-dashboard" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Dashboard</template>
                        Easily judge the demands of your week and your productivity.
                    </b-popover>

                    <b-button variant="light" id="feature-mobile" class="m-1" size="sm">
                        <b-icon icon="phone"/><br/>
                    </b-button>

                    <b-popover target="feature-mobile" :triggers="['hover']" placement="top" variant="warning">
                        <template v-slot:title>Mobile-friendly</template>
                        The full power of Principal Task is available from any internet-connected device.
                    </b-popover>

                    

                    </span>

               

            </b-carousel-slide>

            <b-carousel-slide
                
                
                caption="The Dashboard"
                text="Quickly review your horizon - that which is due soon - as well as helping you to review how productive you've been."
                style="text-shadow: 1px 1px 2px #333">

                <template v-slot:img>
                    <b-img
                        class="d-block img-fluid w-100"
                        :src="require('.././assets/tour/dashboard-animated.png')"
                        alt="Dashboard"/>
                </template>

          
            </b-carousel-slide>

            

            <b-carousel-slide
                caption="Quick Add"
                text="Short on time?  Add tasks quickly from the top of the page."
                style="text-shadow: 1px 1px 2px #333">
                
                <template v-slot:img>
                    <img
                        class="d-block img-fluid w-100"
                        :src="require('.././assets/tour/quick-add-animated.png')"
                        alt="Quickly adding a task">
                </template>

            
            </b-carousel-slide>

            <b-carousel-slide
                caption="Detailed Add"
                text="Stay completely organized by creating a task with all of the important details."
                style="text-shadow: 1px 1px 2px #333">

                <template v-slot:img>
                    <img
                        class="d-block w-100"
                        :src="require('.././assets/tour/detailed-add-animated.png')"
                        alt="Adding a detailed task">
                </template>

                

            </b-carousel-slide>

            <b-carousel-slide>

                <template v-slot:img>
                    <img
                        class="d-block img-fluid w-100"
                        :src="require('.././assets/tour/logo.png')"
                        alt="image slot">
                </template>

                <h3 class="d-none d-sm-block">
                    Data Import
                </h3>

                <p>
                    Bring your Toodledo data with you (others coming soon).
                </p>

                <center>
                    <b-icon 
                        icon="box-arrow-in-down"
                        height="10em"
                        width="10em"
                        class="d-none d-sm-block"/>
                </center>
                

                <center>
                    <b-button :to="{name: 'signup', params: {action: 'signup'}}" 
                        variant="success" class="mt-3">Get Started</b-button>
                </center>

            </b-carousel-slide>

            <b-carousel-slide>

                <template v-slot:img>
                    <img
                        class="d-block img-fluid w-100"
                        :src="require('.././assets/tour/logo.png')"
                        alt="image slot">
                </template>

                <h3 class="d-none d-sm-block">
                    Get Started Today
                </h3>

                <span class="d-sm-none">
                    Free and paid subscriptions available.
                </span>

                
                <b-card-group class="d-none d-sm-flex">
                
                
  

                
                
                <b-card
                    style="color:black">

                    <h4>
                        <b-link :to="{name: 'signup', params: {action: 'signup', tier: 'free'}}">Early Adopter</b-link>
                    </h4>
                    <h6 class="text-secondary">Free Tier</h6>

                    <b-card-text>
                        All of the features of Principal Task with none of the cost.  
                        Recommended for students, individuals with low income, or those who desire
                        to give Principal Task a try.
                    </b-card-text>

                    
                </b-card>

                <b-card
                    style="color:black">
                                
                    <h4>
                        <b-link :to="{name: 'signup', params: {action: 'signup', tier: 'paid'}}">Early Patron</b-link>
                    </h4>
                    
                    <h6 class="text-secondary">Paid Tier</h6>
                    
                    <b-card-text>
                        All of the features of Principal Task as well as the added 
                        benefits of knowing that you are supporting both the growth
                        of a small company and the improvement of Principal Task.  
                    </b-card-text>

                    
                </b-card>

                </b-card-group>

                <center>
                        <b-button :to="{name: 'signup', params: {action: 'signup'}}" 
                            variant="success" class="mt-3">Get Started</b-button>
                    </center>

            </b-carousel-slide>

            </b-carousel>

            </center>


          


      </b-col>
    </b-row>

    
		
		
</span>
</template>
<script>

  import Menu from '@/components/Menu.vue'
  import UserService from '../services/UserService';
  import VueScrollTo from 'vue-scrollto'


	export default {
        name: 'Tour',
        components: {
            Menu
        },
		props: {
		},
		data () {
			return {
                freeHover: false,
                loading: false,
                nextRef: 'cardFeatures',
                token: null,
                signedUp: false,
                slides: [
                    'cardFeatures'
                    , 'cardDashboard'
                    , 'cardQuickAdd'
                    , 'cardDetailAdd'
                    , 'cardImport'
                    , 'joinNow'
                ],
                slideIndex: -1,
            }
		},
		async created() {
        
            this.preparePage()
            this.next()

        },
        methods: {
            next() {
                this.slideIndex += 1

                if(this.slideIndex >= this.slides.length) {
                    this.slideIndex = 0
                }

                this.nextRef = this.slides[this.slideIndex]
                VueScrollTo.scrollTo('#menuRow')
            },
            previous() {

                this.slideIndex -= 1

                if(this.slideIndex < 0) {
                    this.slideIndex = this.slides.length - 1
                }

                this.nextRef = this.slides[this.slideIndex]
                VueScrollTo.scrollTo('#menuRow')

            },
            async preparePage() {
            
                this.loading = true

                this.token = await this.$auth.getTokenSilently()
                this.$store.dispatch('setUserToken', this.token)

                try {
                    this.auth0User = await this.$auth.user
                    let tempUser = await UserService.getUser(this.auth0User.email, this.token)
                        
                    if(typeof tempUser != 'undefined' && tempUser !== null) {
                        
                        this.signedUp = true

                    } else {

                        this.signedUp = false

                    }
                } catch(e) {
                    // Intentionally left blank
                    this.signedUp = false
                    this.loading = false
                }
                

                this.loading = false
            }
		},    

}
</script>
<style scoped>

.loc {
    text-decoration: underline;
    font-style: oblique;
}

/* .opaque-img {
    filter: opacity(0.50)
} */

.opaque-img {
    mix-blend-mode: screen;
}

</style>